module.exports = __webpack_public_path__ + "media/backgrounds/alberto-biondi-pgZIObXHpmE-unsplash-2c32ecb5.jpg";